import React, { Component } from 'react';
import { Droppable } from 'react-beautiful-dnd';
import { withRouter } from 'react-router';

import { ButtonIcon } from 'components/button';
import { I18n } from 'components/translate';
import { inject, PropTypes as MobxPropTypes } from 'mobx-react';
import { QuizService } from 'modules/content/quiz';
import { FileService } from 'modules/file';
import { ENTITY_TYPE } from 'modules/file/constants';
import PropTypes from 'prop-types';

import DraggableProfileComponent from './DraggableProfileComponent';
import DraggableQuizComponent from './DraggableQuizComponent';

import { UploadManager } from '@hotmart/club-files-ui';

@inject((stores) => ({
  profileImages: stores.QuizStore.profileImages
}))
class DroppableComponent extends Component {
  static propTypes = {
    items: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    type: PropTypes.string,
    droppableId: PropTypes.string,
    componentFormat: PropTypes.string,
    questionId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    quizType: PropTypes.string,
    profileImages: MobxPropTypes.observableArray,
    match: PropTypes.shape({
      params: PropTypes.shape({
        id: PropTypes.string
      })
    })
  };

  constructor(props) {
    super(props);
    this.state = {
      items: this.props.items
    };

    this.cloneRef = React.createRef();
  }

  getSnapshotBeforeUpdate() {
    if (JSON.stringify(this.state.items) !== JSON.stringify(this.props.items)) {
      return { items: this.props.items };
    }
    return null;
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (snapshot !== null) {
      this.setState(snapshot);
    }
  }

  addQuestion = (e, index) => {
    e.preventDefault();
    e.stopPropagation();
    const createdQuestion = QuizService.addQuestion(index);

    this.focusQuestion(createdQuestion);
  };

  focusQuestion = (id) => {
    setTimeout(() => {
      const questionEl = document.getElementsByClassName('question-editor')[id];

      questionEl.querySelector('.ql-editor').focus();
      // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    }, 500);
  };

  get addButtons() {
    const { componentFormat, type, questionId } = this.props;
    const { items } = this.state;

    if (componentFormat === 'quiz') {
      if (type === 'question') {
        return (
          <div className="new-component-card">
            <ButtonIcon
              className="btn btn-add-new-component add-new-question"
              transparent
              type="secondary"
              icon="plus"
              onClick={(e) => {
                this.addQuestion(e, items.length - 1);
              }}
            >
              <I18n label="quiz_editor.add_question" />
            </ButtonIcon>
          </div>
        );
      } else if (QuizService.isProfile()) {
        return null;
      } else {
        return (
          <ButtonIcon
            className="btn btn-add-new-component add-new-answer"
            transparent
            type="secondary"
            icon="plus"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              QuizService.addAnswer(questionId);
            }}
          >
            <I18n label="quiz_editor.add_answer" />
          </ButtonIcon>
        );
      }
    } else {
      return (
        <div className="new-component-card">
          <ButtonIcon
            className="btn btn-add-new-component add-new-question"
            transparent
            type="secondary"
            icon="plus"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              QuizService.addProfile();
            }}
          >
            <I18n label="quiz_editor.profiles.add" />
          </ButtonIcon>
        </div>
      );
    }
  }

  onBadgeChange = (files) => {
    files.forEach((file) => {
      QuizService.updateProfileImage(file.profileId, file.id);
    });

    QuizService.updateQuizImages(files);
  };

  onRemoveImage = (file = {}) => {
    QuizService.updateProfileImage(file.profileId, null);
  };

  renderQuiz = (item, index) => {
    const { componentFormat, questionId, quizType, type } = this.props;
    const { items } = this.state;

    return (
      <DraggableQuizComponent
        key={item.id}
        index={index}
        type={type}
        item={item}
        componentFormat={componentFormat}
        itemsQuantity={items.length}
        lastItem={items.length - 1 === index}
        questionId={questionId}
        addQuestion={this.addQuestion}
        focusQuestion={this.focusQuestion}
        quizType={quizType}
      />
    );
  };

  renderProfile = (item, index) => {
    const { type } = this.props;

    return (
      <DraggableProfileComponent
        key={item.id}
        type={type}
        item={item}
        index={index}
        onRemoveImage={this.onRemoveImage}
      />
    );
  };

  render() {
    const { profileImages, match, componentFormat } = this.props;
    const { items } = this.state;
    const renderItem =
      componentFormat === 'quiz' ? this.renderQuiz : this.renderProfile;

    if (!this.state.items) {
      return null;
    }

    let listClassName = 'ordered-list';

    if (this.props.type.indexOf('question') >= 0) {
      listClassName += ' questions-list';
    } else if (this.props.type.indexOf('answer') >= 0) {
      listClassName += ' answers-list';
    } else if (this.props.type.indexOf('profiles') >= 0) {
      listClassName += ' profiles-list';
    }

    return (
      <Droppable
        type={this.props.type}
        droppableId={this.props.droppableId}
        key={this.props.droppableId}
        getContainerForClone={() => this.cloneRef.current}
      >
        {(provided) => (
          <div ref={provided.innerRef}>
            <ol className={listClassName}>
              <UploadManager
                {...this.props}
                entity={ENTITY_TYPE.QUIZ_PROFILE_IMG}
                itemsProp="images"
                entityId={match.params.id}
                images={profileImages}
                onItemsChange={this.onBadgeChange}
                onError={FileService.handleFileException}
              >
                {items.map(renderItem)}
              </UploadManager>
            </ol>
            {provided.placeholder}
            {this.addButtons}
          </div>
        )}
      </Droppable>
    );
  }
}

export default withRouter(DroppableComponent);
